export const NAVIGATION_MAIN_SIZES = {
    sm: 68,
    md: 78,
    lg: 88,
};
